var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSpotlight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1617006061402,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1774,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.333333 256l217.173334 108.8C273.066667 405.333333 256 456.96 256 512s17.066667 106.666667 46.506667 147.2L85.333333 768V256m170.666667-128h512l-108.8 174.506667C618.666667 273.066667 567.04 256 512 256s-106.666667 17.066667-147.2 46.506667L256 128m682.666667 128v512l-217.173334-108.8C750.933333 618.666667 768 567.04 768 512s-17.066667-106.666667-46.506667-147.2L938.666667 256m-170.666667 640H256l108.8-174.506667C405.333333 750.933333 456.96 768 512 768s106.666667-17.066667 147.2-46.506667L768 896M512 341.333333a170.666667 170.666667 0 0 1 170.666667 170.666667 170.666667 170.666667 0 0 1-170.666667 170.666667 170.666667 170.666667 0 0 1-170.666667-170.666667 170.666667 170.666667 0 0 1 170.666667-170.666667m0 85.333334a85.333333 85.333333 0 0 0-85.333333 85.333333 85.333333 85.333333 0 0 0 85.333333 85.333333 85.333333 85.333333 0 0 0 85.333333-85.333333 85.333333 85.333333 0 0 0-85.333333-85.333333z",
    fill: "",
    "p-id": 1775
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpotlight);
export default __webpack_public_path__ + "static/media/icon-spotlight.86e4674e7d3a5a3afe3737602fdbbc43.svg";
export { ForwardRef as ReactComponent };